import React from 'react';
import { Icons } from '../../../components/atoms/SVG';
import { BlockType } from '../../../types/api/ElementType';
import { useBlockContext } from '../../../_lib/BlockFetcher';
import {
  BlockInteractions,
  createButtonObject,
  DISPLAY_TYPE,
  Views as BlockInteractionsViews,
} from '../../../components/organisms/BlockInteractions';
import { PrivilegedGroupsEditView } from '../views/PrivilegedGroupsEditView';
import { PrivilegedGroupsDefaultView } from '../views/PrivilegedGroupsDefaultView';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { PrivilegedGroupsBlockProps } from '../PrivilegedGroupsBlock';

export function PrivilegedGroupsInteractions({ views, activeView }: PrivilegedGroupsBlockProps) {
  const { t } = useSonTranslation('PrivilegedGroups');

  const { uuid } = useBlockContext();
  const buttons = views.edit
    ? createButtonObject(
        BlockInteractionsViews.EDIT,
        Icons.EDIT_PENCIL,
        'PrivilegedGroups:edit',
        DISPLAY_TYPE.COLLAPSIBLE,
        <PrivilegedGroupsEditView {...views.edit} />
      )
    : {};

  return (
    <BlockInteractions
      uuid={uuid}
      elementType={BlockType.applibrary}
      headline={{
        text: t('edit.titleText'),
        hierarchy: 3,
        visible: true,
      }}
      activeView={activeView}
      views={views}
      buttons={buttons}
    >
      <PrivilegedGroupsDefaultView {...views.default} />
    </BlockInteractions>
  );
}
